var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{attrs:{"label":"Titel","rules":_vm.rules.name,"outlined":""},model:{value:(_vm.editingitem.name),callback:function ($$v) {_vm.$set(_vm.editingitem, "name", $$v)},expression:"editingitem.name"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }